/**
 * Données pour le maillage interne SEO – pages "location voiture [ville]"
 * Ancres optimisées : "location voiture [Ville]"
 */

import { cityPath, type SEOLocale } from '@/lib/seo/locale-seo';

export type InternalLinkLocale = SEOLocale;

export interface CityInternalLink {
  slug: string;
  name: string;
  /** Ancre SEO recommandée pour les liens internes (FR) */
  anchor: string;
  /** Ancre SEO pour langue EN */
  anchorEn?: string;
  /** Ancre SEO pour langue AR */
  anchorAr?: string;
  /** @deprecated Utiliser getCityInternalLinkPath(slug, locale) */
  path: string;
}

/** Villes principales pour le maillage (ordre priorité SEO / trafic) */
export const MAIN_CITIES: CityInternalLink[] = [
  {
    slug: 'casablanca',
    name: 'Casablanca',
    anchor: 'location voiture Casablanca',
    anchorEn: 'car rental Casablanca',
    anchorAr: 'تأجير سيارات الدار البيضاء',
    path: '/location-voiture/casablanca',
  },
  {
    slug: 'rabat',
    name: 'Rabat',
    anchor: 'location voiture Rabat',
    anchorEn: 'car rental Rabat',
    anchorAr: 'تأجير سيارات الرباط',
    path: '/location-voiture/rabat',
  },
  {
    slug: 'marrakech',
    name: 'Marrakech',
    anchor: 'location voiture Marrakech',
    anchorEn: 'car rental Marrakech',
    anchorAr: 'تأجير سيارات مراكش',
    path: '/location-voiture/marrakech',
  },
  {
    slug: 'tanger',
    name: 'Tanger',
    anchor: 'location voiture Tanger',
    anchorEn: 'car rental Tangier',
    anchorAr: 'تأجير سيارات طنجة',
    path: '/location-voiture/tanger',
  },
];

/** Page stratégique petit budget / recherche 150 DH — ancres sans promesse de prix fixe */
export const CASABLANCA_150_DH = {
  path: '/location-voiture-casablanca-150-dh',
  anchor: 'Casablanca : petit budget (recherche 150 DH)',
  anchorEn: 'Casablanca: budget offers (150 DH search)',
  anchorAr: 'الدار البيضاء: عروض اقتصادية (بحث 150 درهم)',
} as const;

/** Path canonique SEO par locale pour une ville. */
export const getCityInternalLinkPath = (slug: string, locale: InternalLinkLocale): string =>
  cityPath(slug, locale);

/** Returns the anchor text for a city link in the given locale. */
export const getCityLinkAnchor = (city: CityInternalLink, locale: InternalLinkLocale): string => {
  if (locale === 'ar' && city.anchorAr) return city.anchorAr;
  if (locale === 'en' && city.anchorEn) return city.anchorEn;
  return city.anchor;
};

/** Returns the 150 DH page anchor in the given locale. */
export const getCasablanca150DhAnchor = (locale: InternalLinkLocale): string => {
  if (locale === 'ar') return CASABLANCA_150_DH.anchorAr;
  if (locale === 'en') return CASABLANCA_150_DH.anchorEn;
  return CASABLANCA_150_DH.anchor;
};

/** Récupérer les liens villes pour afficher "autres villes" (exclure une ville courante) */
export const getOtherCitiesLinks = (excludeSlug: string): CityInternalLink[] =>
  MAIN_CITIES.filter((c) => c.slug !== excludeSlug);
